export function getTrialMaxUsage(trial) {
    if (!trial) {
        return undefined;
    }
    if (trial.state === 'ACTIVE') {
        return trial.maxUsage;
    }
    return undefined;
}
